import React from 'react';
import { connect } from 'react-redux';
import CenterPanelCreate from './centerPanelCreate';
import RightPanelCreate from './rightPanelCreate';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelUpdate from './rightPanelUpdate';
import CenterPanelView from './centerPanelView';
import RightPanelView from './rightPanelView';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
export default class CreateUpdateWaitingArea extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
  }

  openInsertHelp() {
    window.open(APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpCreate, '_blank');
  }
  openUpdateHelp() {
    window.open(APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpEditProperties, '_blank');
  }

  render() {
    let rightPanel = {};
    let centerPanel = {};
    let title = undefined;
    let subtitle = undefined;
    let trimmedGroup = {};
    let helpFunc = undefined;
    let orgName = this.props.waitingArea ? this.props.waitingArea.organisationName : '';
    var updatingWaitingAreaName = (this.props.waitingArea ? this.props.waitingArea.name : '') + ' (' + orgName + ')';
    if (this.props.updateOrInsert == 'insert') {
      rightPanel = <RightPanelCreate waitingAreaForm={this.props.waitingAreaForm} />;
      centerPanel = <CenterPanelCreate waitingAreaForm={this.props.waitingAreaForm} />;
      helpFunc = this.openInsertHelp;
      title = APP.LANGUAGE.CreateWaitingArea.Title;
    } else if (this.props.updateOrInsert == 'update') {
      rightPanel = (
        <RightPanelUpdate waitingArea={this.props.waitingArea} waitingAreaForm={this.props.waitingAreaForm} />
      );
      centerPanel = (
        <CenterPanelUpdate waitingAreaForm={this.props.waitingAreaForm} waitingArea={this.props.waitingArea} />
      );
      helpFunc = this.openUpdateHelp;
      title = APP.LANGUAGE.WaitingAreaGeneralInfo.TitleUpdate;
      subtitle = updatingWaitingAreaName;
    } else {
      rightPanel = <RightPanelView waitingAreaForm={this.props.waitingAreaForm} />;
      centerPanel = <CenterPanelView waitingArea={this.props.waitingArea} />;
      title = APP.LANGUAGE.WaitingAreaGeneralInfo.TitleView;
      subtitle = updatingWaitingAreaName;
    }
    let showModal = false;
    if (this.props.updateOrInsert == 'insert') {
      showModal = this.props.showCreateWaitingAreaModal;
    } else if (this.props.updateOrInsert == 'update') {
      showModal = this.props.showUpdateWaitingAreaModal;
    } else {
      showModal = this.props.showViewWaitingAreaModal;
    }

    return (
      <Modal show={showModal} hideWhenClickAway={false} className={this.props.updateOrInsert + '-waiting-area'}>
        <PopupHeader
          helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpGeneralInformation}
          title={title}
          subtitle={subtitle}
        />
        <div className="content">
          <div className="main-ui-container waiting-area-update pdbxxl">
            <div id="righthandfloatingpanel">
              <div className="right ui rail">
                <div className="ui sticky">{rightPanel}</div>
              </div>
              {centerPanel}
              <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
